// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_BATTERY_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/is-editable.js